export const MENU_ITEMS = [
  {
    id: 'portfolio',
    name: '投資実績'
  },
  {
    id: 'support',
    name: 'サポート'
  },
  {
    id: 'about',
    name: '会社情報'
  }
] as const
